import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);


const store = new Vuex.Store({
    state: {
        isLogin: 0,     //初始时候给一个 isLogin=0 表示用户未登录
        apiNameArr: [],
        newApiNameArr: []
    },
    mutations: {
        //set方法 传递参数
        changeLogin(state, data) {
            state.isLogin = data;

        },
        changeApiValue(state, newVal) {

            state.apiNameArr = newVal;
        },
        changeNewApiValue(state, newApiVal) {

            state.newApiNameArr = newApiVal;
        }
    },
    getters: {
    },
    actions: {
    },
    getters: {
    },
    modules: {
    }
})

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js